import { a11yCard } from '../../../ts/helper';

/** Selector for any instance of this component */
const selector = '[is="atom-teaser"]';

/**
 * Friendation component
 */
export const atomTeaser = () => {
  const components: HTMLElement[] = Array.from(
    document.querySelectorAll(selector)
  );

  components.forEach((component) => {
    const link = component.querySelector<HTMLAnchorElement>('a.title-link');
    if (!link) return;

    a11yCard(component, link);
  });
};
